import React from 'react'
import SarasRichText from '../../input/sarasRichText/SarasRichText';
import SarasAC from '../../input/autocomplete/SarasAutocomplete2'
import * as fn from "../../../helper/uiFunctions";

const FormRichText = (props) => {
    const { formObject, action, rowKey, headerKey,roClass, roStyle, ...restProps } = props;

    const viewData = formObject.getFormData(rowKey, headerKey, action.paramName);
    const hide = formObject.getValueFromKey(viewData, "dataList.isHid", "0");
    const isRO = formObject.getValueFromKey(viewData, "dataList.isRO", "0");

    const onInputChange = (e, value) => {
        // console.log("form input changed", e, action, value);

        if(action.InputType === 'ac'){
            if(action.actionParam){
                action.actionParam["rowId"] = value.key;
            }
        }

        if (formObject.onFormValueChange) formObject.onFormValueChange(action, rowKey, headerKey, value);

        //send the parameters reqired by the form
        if (action.actionId) formObject.onFormAction(action, rowKey, headerKey);
    }

    const onGetDependantValue = (formula) => {
        let params = formObject.getDependantValue(formula, rowKey, headerKey, action.paramName);

        return params;
    };

    if (viewData && fn.compareNumber(hide, 0)) {
        if(fn.compareNumber(isRO, 1)) {
            return (<span className={roClass} style={roStyle} >{viewData.valF || viewData.val}</span>)
        }
        else if (action.InputType === 'ac') {
            return (
                <SarasAC onChange={onInputChange} value={viewData.val} label={viewData.valF} {...action}  {...restProps} onGetDependantValue={onGetDependantValue} />
            )
        }
        else {
            return (
                <SarasRichText onChange={onInputChange} value={viewData.valF || viewData.val}  {...restProps} />
            )
        }
    }

    return (null);
}

export default FormRichText